export const drawerWidth = 384;
export const fadeInDuration = 450;

// colors
export const brandAccentColor = 'rgba(255, 122, 0, 1)';
export const brandBackgroundGradient =
  'linear-gradient(90deg, #FF7A00 50%, #FF9801 100%)';
